<template>
  <div>
    <AboutSection
          :image1="require('@/assets/AllSystem/pthgjilan/image1.jpg')"
          :image2="require('@/assets/AllSystem/pthgjilan/image2.png')"
          :section1="$t('menus.pthgjilan.about_us.section1')"
          :section2Title="$t('menus.pthgjilan.about_us.section2.title')"
          :section2Content="$t('menus.pthgjilan.about_us.section2.content')"
    />
  </div>
</template>

<script>
 import AboutSection from '../share/AboutUs.vue'


export default {
    components: {
      AboutSection
    },

}
</script>

  <style scoped>
  .textBox:first-child{
    border-right:4px solid #F5BD2A;
    padding-right:10px;
  }
  .textBox:nth-child(2){
    border-left:4px solid #F5BD2A;
    padding-left:10px;
  }
  </style>